export default __webpack_public_path__ + "static/media/condor.08064158.gif";